import ApiServices from "./ApiServices";

/**
 * Fawaterak Payment Gateway Service
 * Handles all Fawaterak-related API calls
 */
const FawaterakService = {
  /**
   * Fetches available Fawaterak payment methods
   * GET Payment/Fawaterak/payment-methods
   * @returns {Promise<{status: string, data: Array<{payment_method_id: number, name_en: string, name_ar: string, redirect: string, logo: string}>}>}
   */
  getPaymentMethods: async () => {
    try {
      const response = await ApiServices.get("Payment/Fawaterak/payment-methods");
      return response;
    } catch (error) {
      
      throw error;
    }
  },

  /**
   * Initiates a Fawaterak payment transaction
   * POST Payment/Fawaterak/initiate
   * @param {Object} payload
   * @param {number} payload.cart_total - Total cart amount
   * @param {string} payload.currency - Currency code (e.g., "EGP")
   * @param {number} payload.payment_method_id - Selected payment method ID
   * @param {string} payload.customer_first_name - Customer first name
   * @param {string} payload.customer_last_name - Customer last name
   * @param {string} payload.customer_email - Customer email
   * @param {string} payload.customer_phone - Customer phone
   * @param {string} payload.customer_address - Customer address
   * @param {Array<{name: string, price: number, quantity: number}>} payload.cart_items - Cart items
   * @param {string} payload.merchant_reference_number - Merchant reference number
   * @returns {Promise<{checkout_url: string, intent_key: string, transaction_id: number}>}
   */
  initiatePayment: async (payload) => {
    try {
      const response = await ApiServices.post("Payment/Fawaterak/initiate", payload);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default FawaterakService;
